import { useState } from 'react'
import { Calendar, Briefcase } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function WorkingDays() {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [includeWeekends, setIncludeWeekends] = useState(false)
  const [result, setResult] = useState(null)

  const calculateWorkingDays = () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates')
      return
    }

    const start = new Date(startDate)
    const end = new Date(endDate)

    if (start > end) {
      alert('Start date must be before end date')
      return
    }

    let workingDays = 0
    let totalDays = 0
    let weekends = 0
    const currentDate = new Date(start)

    while (currentDate <= end) {
      totalDays++
      const dayOfWeek = currentDate.getDay()
      
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        weekends++
        if (includeWeekends) {
          workingDays++
        }
      } else {
        workingDays++
      }

      currentDate.setDate(currentDate.getDate() + 1)
    }

    setResult({
      workingDays,
      totalDays,
      weekends,
      businessDays: workingDays
    })
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-3">Start Date:</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="input w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-semibold mb-3">End Date:</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="input w-full"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={includeWeekends}
                onChange={(e) => setIncludeWeekends(e.target.checked)}
                className="w-4 h-4"
              />
              <span className="text-gray-700">Include weekends in working days</span>
            </label>
          </div>

          <Button onClick={calculateWorkingDays} variant="primary" className="w-full">
            <Briefcase className="w-5 h-5 mr-2" />
            Calculate Working Days
          </Button>
        </Card.Body>
      </Card>

      {result && (
        <Card>
          <Card.Body>
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Results:</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-orange-50 rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">{result.workingDays}</div>
                  <div className="text-sm text-gray-600">Working Days</div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold text-gray-600 mb-2">{result.totalDays}</div>
                  <div className="text-sm text-gray-600">Total Days</div>
                </div>
                <div className="bg-blue-50 rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{result.weekends}</div>
                  <div className="text-sm text-gray-600">Weekend Days</div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}

      {!result && (
        <Card>
          <Card.Body className="text-center py-12">
            <Briefcase className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Select start and end dates to calculate working days</p>
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

